export const retrieveDescriptions = (xml) => {
  if (!hasTextNodes(xml)) return;
  const paragraphs = Array.from(xml.querySelectorAll("p"));
  return paragraphs
    .map((p) => {
      let descriptionText = "";
      for (const child of p.childNodes) {
        // if there are multiple <p> elements inside xml, display the full text
        // otherwise only display the text except content within xref
        if (paragraphs.length > 1 || child.nodeType === Node.TEXT_NODE) {
          descriptionText += child.textContent;
        }
      }
      return descriptionText.trim();
    })
    .filter((text) => text.length > 0)
    .map((text) => text.replaceAll(";", ""))
    .join("<br/>");
};


export const xrefSet = (xml) => {
  const seen = new Set();
  const xrefs = xml.querySelectorAll("xref");

  return Array.from(xrefs).reduce((acc, xref) => {
    const text = xref.textContent.trim();
    const href = xref.getAttribute("href");
    const key = text.toLowerCase();

    if (!seen.has(key)) {
      seen.add(key);

      if (href) {
        acc.push({ text, href });
      } else {
        acc.push(text);
      }
    }

    return acc;
  }, []);
};


const hasTextNodes = (xml) =>
  Array.from(xml.querySelectorAll("p")).some((p) =>
    Array.from(p.childNodes).some((child) => child.nodeType === Node.TEXT_NODE)
  );
